import { BrowserRouter, Route, Routes, Navigate, HashRouter } from 'react-router-dom';
import './App.css';
import HomePage from './Pages/HomePage';
import RelatorioPage from './Pages/RelatorioPage';
import CredentialsPage from './Pages/CredentialsPage';
import ConfiguracoesPage from './Pages/ConfiguracoesPage';
import "react-datepicker/dist/react-datepicker.css";
import LoginPage from './Pages/LoginPage';
import RegisterPage from './Pages/RegisterPage';
import ProfilePage from './Pages/ProfilePage';
import NotFoundPage from './Pages/NotFoundPage';
import { AuthProvider } from './Contexts/AuthContext';
import ProductPage from './Pages/ProductPage';
import CheckoutPage from './Pages/CheckoutPage';


function App() {
  // auth.js
  const isAuthenticated = () => {
    const token = localStorage.getItem('token'); // ou o nome que você está usando para armazenar o token
    return token !== null; // Retorna true se o token existir, caso contrário, false
  };
  return (
    <HashRouter>
      <AuthProvider>
        <Routes>
          <Route path='/home' element={isAuthenticated() ? <HomePage /> : <Navigate to="/login" />} />
          <Route path='/produtos' element={isAuthenticated() ? <ProductPage /> : <Navigate to="/login" />} />
          <Route path='/relatorio' element={isAuthenticated() ? <RelatorioPage /> : <Navigate to="/login" />} />
          <Route path='/credentials' element={isAuthenticated() ? <CredentialsPage /> : <Navigate to="/login" />} />
          <Route path='/configuracoes' element={isAuthenticated() ? <ConfiguracoesPage /> : <Navigate to="/login" />} />
          <Route path='/login'  element={isAuthenticated() ?   <Navigate to="/" /> : <LoginPage />} />
          <Route path='/register' element={<RegisterPage />} />
          <Route path='/checkout/*' element={<CheckoutPage />} />
          <Route path='/profile' element={isAuthenticated() ? <ProfilePage /> : <Navigate to="/login" />} />
          <Route path='/' element={isAuthenticated() ? <Navigate to={'/home'}/> : <Navigate to="/login" />}  /> 
        </Routes>
      </AuthProvider>
    </HashRouter>
  );
}

export default App;